// @flow
import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";

type LoadingProgressPropsType = {
  size?: number,
  isLinear?: boolean
};

class LoadingProgress extends Component<LoadingProgressPropsType, *> {
  render(): React$Element<*> {
    if (this.props.isLinear) {
      return <LinearProgress color="primary" />;
    } else {
      return (
        <CircularProgress
          size={this.props.size ? this.props.size : 100}
          color="primary"
        />
      );
    }
  }
}

export default LoadingProgress;
